import { Controller } from "@hotwired/stimulus"

// Mostra un toast (sonner) quando l'elemento entra nella pagina: flash del server o <turbo-stream> che lo aggiunge.
// <div data-controller="toast" data-toast-type-value="success" data-toast-message-value="Salvato"></div>
export default class extends Controller {
  static values = { type: { type: String, default: "message" }, message: String, description: String, duration: Number }

  connect() {
    const fn = window.toast?.[this.typeValue] || window.toast
    const opzioni = {}
    if (this.descriptionValue) opzioni.description = this.descriptionValue
    if (this.durationValue) opzioni.duration = this.durationValue
    if (fn && this.messageValue) fn(this.messageValue, Object.keys(opzioni).length ? opzioni : undefined)
    this.element.remove()
  }
}
